/* Ausstecher anpassen (Entwurf 24.10.2026, nur Testtheme). Repo em/theme/anpassen.js, im Theme assets/keks-anpassen.js;
   Section keks-anpassen (em/theme/anpassen-seite.liquid) auf <Produkt>?view=anpassen.

   Grundrisse und Prüfung rechnet produktion.cookiehaus.de (anpassen.py) mit derselben Rechnung wie die STL. Hier werden
   sie zu Prismen (three.js): Wand bis zur Schneidhöhe, Prägerippen bis Schneidhöhe minus Stempeltiefe, Handlauf und
   Supportgitter fest. Größe ziehen skaliert das Modell sofort, nach dem Loslassen kommt das genaue vom Server; die
   Höhen ändern nur die Prismen, ohne zu fragen. Längste und kürzeste Seite hängen über das Seitenverhältnis zusammen
   (Schloss). In den Warenkorb: Variante All-in-One oder <SKU>-S mit Größe, Schneidhöhe, Stempeltiefe und _Anpassung.
   Nachbestellung einer Sonderanfertigung (privater Artikel, eine Variante): Stempel & Ausstecher über die Eigenschaft
   „Ausführung“ (app.ausfuehrung); als Stempel bestellt ist All-in-One gesperrt (anpassen.herkunft).

   Eigener Text (Lauritz 03.11.2026): bis 3 Zeilen in den Schriften von Name & Text, Prägung vom Server
   (/anpassen/text), frei in der Silhouette verschiebbar (Fläche `frei` aus /anpassen/modell). Er prägt so hoch wie
   der Stempel: All-in-One bis zu den Prägerippen, Stempel & Ausstecher als Relief auf der Platte. Verschoben wird in
   der Keks-Ansicht (2D, wie auf dem Keks), an den Kreisen links und rechts gedreht, an den Mittellinien des Ausstechers
   rastet er ein; im 3D-Modell steht er wie jede Prägung spiegelverkehrt. Je Zeile nur so viele Zeichen, wie in
   kleinster lesbarer Höhe hineinpassen (`textplatz` aus /anpassen/modell, je Schrift). Liegt der Text, rechnet der
   Server das Modell samt Text noch einmal wie gedruckt (/anpassen/modell mit t, s, g, x, y, w: Prägung, Supportlinien
   durch die Zeilen, Stege — anpassen.druck_lagen); das 3D zeigt dann dieses, in den Warenkorb geht es erst damit. Jede Änderung
   gegenüber dem Standard kostet den Aufpreis (Section: Aufpreis-Produkt oder nur angezeigt) und hebt die
   Keks-Garantie auf — das sagen die Hinweise unter Größe und Text, einen Haken davor braucht es nicht (Lauritz
   03.11.2026: „Sie sollen das nicht extra verifizieren müssen“). */

// Fassung der Antworten: neu zählen, wenn sich anpassen.py ändert (der Browser hält sie sonst bis zu einer Stunde)
const STAND = '6';
const TEXT_STAND = '1';                           // /text/optionen von Name & Text (Schriften mit Muster)
const THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.169.0/+esm';
const ORBIT_URL = 'https://cdn.jsdelivr.net/npm/three@0.169.0/examples/jsm/controls/OrbitControls.js/+esm';
const NAME = { allinone: 'All-in-One', stempel: 'Stempel & Ausstecher' };
const RAND = 1;                                   // svg_zu_stl.RAND_MM: der Handlauf zählt zur Größe
const SCHRIFT = { min: 5, max: 40, standard: 10 };  // anpassen.SCHRIFT_MM: Versalhöhe in mm
const ZEILEN = 3;
const ZEICHEN = 30;                               // text_ausstecher.ZEICHEN_MAX je Zeile
const RASTEN_PX = 8;                              // so nah an der Mittellinie rastet der Text ein
const RASTEN_GRAD = 4;                            // so nah an 0°, 45°, 90° … rastet die Drehung ein
const grad = (dy, dx) => (Math.atan2(dy, dx) * 180) / Math.PI;

const zahl = (mm) => (mm / 10).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const cm = (mm) => `${zahl(mm)} cm`;
const el = (tag, klasse, text) => {
  const e = document.createElement(tag);
  if (klasse) e.className = klasse;
  if (text != null) e.textContent = text;
  return e;
};
const svgUrl = (svg) => 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
const SVGNS = 'http://www.w3.org/2000/svg';

/* Polygone aus anpassen.py ([[x, y, x, y, …] außen, Loch, …]) als SVG-Pfad */
const pfad = (polys) => polys.map((ringe) => ringe.map((r) => {
  let d = '';
  for (let i = 0; i < r.length; i += 2) d += `${i ? 'L' : 'M'}${r[i]} ${r[i + 1]}`;
  return `${d}Z`;
}).join('')).join('');

/* Liegt der Punkt in einem der Polygone (außen drin, in keinem Loch)? */
const imRing = (x, y, r) => {
  let drin = false;
  for (let i = 0, j = r.length - 2; i < r.length; j = i, i += 2) {
    const xi = r[i]; const yi = r[i + 1]; const xj = r[j]; const yj = r[j + 1];
    if ((yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) drin = !drin;
  }
  return drin;
};
const inFlaeche = (x, y, polys) => polys.some(([aussen, ...loecher]) => imRing(x, y, aussen)
  && !loecher.some((l) => imRing(x, y, l)));

const VORLAGE = `
  <div class="kan__buehne">
    <div class="kan__flaeche" data-flaeche>
      <div class="kan__ansichten" role="tablist" aria-label="Ansicht">
        <button type="button" role="tab" class="kan__ansicht" data-ansicht="3d" aria-selected="true">3D</button>
        <button type="button" role="tab" class="kan__ansicht" data-ansicht="keks" aria-selected="false">Keks</button>
      </div>
      <svg class="kan__keks" data-keks hidden xmlns="${SVGNS}" role="img" aria-label="So sieht der Abdruck im Keks aus"></svg>
      <span class="kan__laedt" data-laedt aria-hidden="true"></span>
      <span class="kan__tipp" data-tipp>Ziehen zum Drehen</span>
      <p class="kan__ohne3d">Die 3D-Ansicht lädt hier gerade nicht.</p>
    </div>
    <p class="kan__masse" data-masse aria-live="polite"></p>
  </div>
  <div class="kan__rechts" data-rechts>
    <fieldset class="kan__art" data-art hidden>
      <legend class="kan__label">Ausführung</legend>
      <div class="kan__pillen">
        <label class="kan__pille"><input type="radio" name="kan-art" value="allinone"><span>All-in-One</span></label>
        <label class="kan__pille"><input type="radio" name="kan-art" value="stempel"><span>Stempel &amp; Ausstecher</span></label>
      </div>
      <p class="kan__klein kan__art-hinweis" data-art-hinweis hidden></p>
    </fieldset>
    <div class="kan__gruppe" data-textfeld>
      <div class="kan__kopfzeile">
        <label class="kan__label" for="kan-text">Text</label>
        <span class="kan__klein">optional</span>
      </div>
      <textarea id="kan-text" class="field__input keks-input kan__text" rows="1" placeholder="z. B. Paul"
        autocomplete="off" autocapitalize="sentences" spellcheck="false" data-text></textarea>
      <p class="kan__klein" data-platz aria-live="polite"></p>
      <div class="kan__textmehr" data-textmehr hidden>
        <div class="kan__schriften" data-schriften role="radiogroup" aria-label="Schrift"></div>
        <div class="kan__regler">
          <label class="kan__zeile" for="kan-g"><span>Schrifthöhe</span><output data-aus="g"></output></label>
          <input id="kan-g" type="range" min="${SCHRIFT.min}" max="${SCHRIFT.max}" step="1" value="${SCHRIFT.standard}" data-regler="g">
        </div>
        <div class="kan__textstand" data-textstand aria-live="polite"></div>
        <p class="kan__hinweis" data-hinweis-text></p>
      </div>
    </div>
    <div class="kan__gruppe" role="group" aria-labelledby="kan-groesse">
      <div class="kan__kopfzeile">
        <span class="kan__label" id="kan-groesse">Größe</span>
        <span class="kan__klein">gekoppelt im Seitenverhältnis</span>
      </div>
      <div class="kan__paar">
        <div class="kan__regler">
          <label class="kan__zeile" for="kan-l"><span>Längste Seite</span><output data-aus="l"></output></label>
          <input id="kan-l" type="range" data-regler="l">
        </div>
        <span class="kan__schloss" title="Beide Seiten ändern sich zusammen" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><rect x="4" y="9" width="12" height="8" rx="2"/><path d="M7 9V6.5a3 3 0 0 1 6 0V9"/></svg>
        </span>
        <div class="kan__regler">
          <label class="kan__zeile" for="kan-k"><span>Kürzeste Seite</span><output data-aus="k"></output></label>
          <input id="kan-k" type="range" data-regler="k">
        </div>
      </div>
      <div class="kan__spanne" aria-hidden="true"><span data-spanne></span></div>
      <p class="kan__klein" data-spanne-text></p>
      <p class="kan__klein kan__garantie" data-hinweis-groesse></p>
    </div>
    <div class="kan__regler">
      <label class="kan__zeile" for="kan-h"><span>Schneidhöhe</span><output data-aus="h"></output></label>
      <input id="kan-h" type="range" step="1" data-regler="h">
      <p class="kan__klein" data-hinweis="h"></p>
    </div>
    <div class="kan__regler" data-nur="allinone">
      <label class="kan__zeile" for="kan-t"><span>Stempeltiefe</span><output data-aus="t"></output></label>
      <input id="kan-t" type="range" step="1" data-regler="t">
      <p class="kan__klein" data-hinweis="t"></p>
    </div>
    <p class="kan__klein" data-nur="stempel" hidden>Den Stempel drückst du mit dem Griff selbst so tief in den Teig, wie du magst.</p>
    <div class="kan__pruefung" data-pruefung role="status" aria-live="polite"></div>
    <button type="button" class="button kan__kaufen" data-kaufen disabled><span data-knopf>In den Warenkorb</span></button>
    <p class="keks-fehler" data-fehler role="alert" hidden></p>
    <p class="kan__links">
      <button type="button" class="kan__link" data-zuruecksetzen>Auf Standard zurücksetzen</button>
      <a class="kan__link" data-zurueck>Zurück zum Produkt</a>
    </p>
  </div>`;

/* Die 3D-Bühne: Szene, Licht, 1-cm-Raster als Maßstab, je Baustein ein Prisma der Höhe 1 (skaliert in z). */
class Buehne {
  constructor(flaeche) {
    this.flaeche = flaeche;
    this.teile = {};
    this.gruppen = {};
    this.bereit = this.starten();
  }

  async starten() {
    const [T, { OrbitControls }] = await Promise.all([import(THREE_URL), import(ORBIT_URL)]);
    this.T = T;
    const r = new T.WebGLRenderer({ antialias: true, alpha: true });
    r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    r.domElement.className = 'kan__leinwand';
    this.flaeche.prepend(r.domElement);
    this.renderer = r;
    this.szene = new T.Scene();
    this.kamera = new T.PerspectiveCamera(28, 1, 1, 5000);
    this.szene.add(new T.HemisphereLight(0xffffff, 0xbfa985, 1.35));
    const sonne = new T.DirectionalLight(0xffffff, 1.6);
    sonne.position.set(-140, 260, 180);
    const gegen = new T.DirectionalLight(0xfff1de, 0.4);
    gegen.position.set(160, 90, -140);
    this.szene.add(sonne, gegen, new T.GridHelper(600, 60, 0xc2b092, 0xd8c9b0));    // 1 cm je Kästchen
    this.pla = new T.MeshStandardMaterial({ color: 0xf7f4ee, roughness: 0.55 });
    this.modell = new T.Group();
    this.modell.rotation.x = -Math.PI / 2;            // die Höhe des Ausstechers (z) nach oben, Schneide oben wie im Foto
    this.szene.add(this.modell);
    this.steuerung = new OrbitControls(this.kamera, r.domElement);
    // ohne Zoom: das Mausrad scrollt die Seite, die Kamera rückt selbst auf das Modell
    Object.assign(this.steuerung, { enableDamping: true, enablePan: false, enableZoom: false, maxPolarAngle: Math.PI * 0.46 });
    this.steuerung.addEventListener('start', () => this.flaeche.classList.add('kan__flaeche--gedreht'), { once: true });
    new ResizeObserver(() => this.groesse()).observe(this.flaeche);
    new IntersectionObserver(([e]) => r.setAnimationLoop(e.isIntersecting ? () => this.malen() : null)).observe(this.flaeche);
    this.groesse();
  }

  groesse() {
    const { clientWidth: b, clientHeight: h } = this.flaeche;
    if (!b || !h) return;
    this.renderer.setSize(b, h, false);
    this.kamera.aspect = b / h;
    this.kamera.updateProjectionMatrix();
    if (this.kugel) this.einpassen(true);
  }

  malen() {
    if (this.ziel) {                                  // Kamera gleitet auf das neue Modell
      const s = this.steuerung;
      const k = matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0.15;
      s.target.lerp(this.ziel.mitte, k);
      const weg = this.kamera.position.clone().sub(s.target);
      const ist = weg.length();
      this.kamera.position.copy(s.target).add(weg.setLength(ist + (this.ziel.abstand - ist) * k));
      if (Math.abs(ist - this.ziel.abstand) < 0.05 && s.target.distanceTo(this.ziel.mitte) < 0.05) this.ziel = null;
    }
    this.steuerung.update();
    this.renderer.render(this.szene, this.kamera);
  }

  prisma(polys) {
    const T = this.T;
    const linie = (flach, Art) => {
      const p = [];
      for (let i = 0; i < flach.length; i += 2) p.push(new T.Vector2(flach[i], flach[i + 1]));
      return new Art(p);
    };
    const formen = polys.map(([aussen, ...loecher]) => {
      const f = linie(aussen, T.Shape);
      f.holes = loecher.map((l) => linie(l, T.Path));
      return f;
    });
    return new T.Mesh(new T.ExtrudeGeometry(formen, { depth: 1, bevelEnabled: false, curveSegments: 1 }), this.pla);
  }

  /* Die Bausteine einer Antwort von anpassen.py; Stempel & Ausstecher: Ring links, Stempel (Prägung oben) rechts. */
  setzen(a) {
    this.text?.parent?.remove(this.text);            // der Text bleibt, nur die Bausteine kommen neu
    for (const g of [...this.modell.children]) {
      g.traverse((m) => m.geometry && m.geometry.dispose());
      this.modell.remove(g);
    }
    this.modell.scale.set(1, 1, 1);
    this.teile = {};
    this.art = a.art;
    this.masse = a.masse;
    const gruppe = (namen) => {
      const g = new this.T.Group();
      for (const n of namen) {
        if (a.teile && a.teile[n] && a.teile[n].length) g.add((this.teile[n] = this.prisma(a.teile[n])));
      }
      this.modell.add(g);
      return g;
    };
    if (a.art !== 'stempel') {
      this.gruppen = { praegung: gruppe(['rand', 'gitter', 'rippen', 'wand']) };
      this.textEinhaengen();
      return;
    }
    const ring = gruppe(['lippe', 'wand', 'kante']);
    const stempel = gruppe(['platte', 'relief']);
    this.gruppen = { praegung: stempel };
    const kasten = (m) => (m ? (m.geometry.computeBoundingBox(), m.geometry.boundingBox) : null);
    const r = kasten(this.teile.lippe);
    const s = kasten(this.teile.platte);
    if (r && s) {
      ring.position.x = -6 - r.max.x;
      stempel.position.x = 6 - s.min.x;
    }
    this.textEinhaengen();
  }

  /* Eigener Text: liegt in der Gruppe mit der Prägung (beim Stempel auf der Platte), an seiner Stelle in mm */
  textSetzen(polys) {
    if (this.text) {
      this.text.parent?.remove(this.text);
      this.text.geometry.dispose();
      this.text = null;
    }
    if (polys && polys.length) {
      this.text = this.prisma(polys);
      this.text.visible = this.textAn !== false;
    }
    this.textEinhaengen();
  }

  /* Rechnet der Server das Modell samt Text, steckt der Text schon in dessen Prägung: das eigene Prisma ausblenden */
  textSichtbar(an) {
    this.textAn = an;
    if (this.text) this.text.visible = an;
  }

  textEinhaengen() {
    if (!this.text || !this.gruppen.praegung) return;
    this.gruppen.praegung.add(this.text);
    if (this.w) this.hoehen(this.w);
  }

  textLage(x, y, w) {
    if (!this.text) return;
    this.text.position.set(x, y, this.text.position.z);
    this.text.rotation.z = (w * Math.PI) / 180;      // dieselbe Drehung wie rotate() der Keks-Ansicht (Grundriss-Koordinaten)
  }

  hoehen(w) {
    this.w = w;
    const t = this.teile;
    const m = this.masse || {};
    const z = (teil, hoch, ab = 0) => {
      if (!teil) return;
      teil.scale.z = Math.max(hoch, 0.01);
      teil.position.z = ab;
    };
    if (this.art === 'stempel') {
      z(t.lippe, m.lippe);
      z(t.wand, w.ring - m.zulauf);
      z(t.kante, w.ring);
      z(t.platte, m.platte);
      z(t.relief, m.relief, m.platte);
      z(this.text, m.relief, m.platte);              // so hoch wie die Prägung des Stempels
    } else {
      z(t.rand, m.lippe);
      z(t.gitter, m.gitter);
      z(t.rippen, w.h - w.t);
      z(t.wand, w.h);
      z(this.text, w.h - w.t);                       // so hoch wie die Prägerippen
    }
  }

  /* Beim Ziehen sofort: das angezeigte Modell in der Fläche gestreckt, bis das genaue kommt */
  skalieren(f) {
    this.modell.scale.set(f, f, 1);
  }

  einpassen(sofort) {
    const T = this.T;
    this.modell.updateMatrixWorld(true);
    const kasten = new T.Box3().setFromObject(this.modell);
    if (kasten.isEmpty()) return;
    this.kugel = kasten.getBoundingSphere(new T.Sphere());
    const halb = (this.kamera.fov * Math.PI) / 360;
    const winkel = Math.min(halb, Math.atan(Math.tan(halb) * this.kamera.aspect));
    this.ziel = { mitte: this.kugel.center.clone(), abstand: (this.kugel.radius / Math.sin(winkel)) * 1.04 };
    if (sofort) {
      this.steuerung.target.copy(this.ziel.mitte);
      const blick = this.gezeigt ? this.kamera.position.clone().sub(this.steuerung.target).normalize()
        : new T.Vector3(0, Math.sin(0.95), Math.cos(0.95));
      this.kamera.position.copy(this.ziel.mitte).add(blick.multiplyScalar(this.ziel.abstand));
      this.gezeigt = true;
      this.ziel = null;
    }
  }
}

/* Die Keks-Ansicht: der Abdruck, wie er im Keks steht (die Grundrisse sind gespiegelt wie die STL, x, y -> -x, -y;
   hier zurück, eine halbe Drehung: Drehsinn und Winkel bleiben gleich). Der eigene Text lässt sich mit Maus oder
   Finger verschieben, ein Tipp auf den Keks setzt ihn dorthin, die Pfeiltasten schieben ihn um 1 mm. Die Kreise links
   und rechts drehen ihn um seine Mitte. Beim Ziehen zeigen die Mittellinien des Ausstechers, ob er waagerecht oder
   senkrecht mittig sitzt (einrasten tut KeksAnpassen). tun.ziehen(x, y) bekommt die gewünschte Mitte in mm
   (Grundriss-Koordinaten), tun.drehen(w) den Winkel in Grad (im Uhrzeigersinn, wie auf dem Keks). */
class KeksAnsicht {
  constructor(svg, tun) {
    this.svg = svg;
    this.tun = tun;
    this.winkel = 0;
    const griff = (seite) => `<g class="kan__keks-dreh" data-dreh="${seite}" role="button" aria-label="Text drehen">`
      + '<circle class="kan__keks-dreh-feld" r="1"/><circle class="kan__keks-dreh-kreis" r="0.62"/>'
      + '<path class="kan__keks-dreh-pfeil" d="M0.32 -0.12A0.34 0.34 0 1 1 0.12 -0.32M0.12 -0.32L0.3 -0.42M0.12 -0.32L0.2 -0.14"/></g>';
    svg.innerHTML = '<g data-keks-inhalt transform="scale(-1 -1)">'
      + '<path class="kan__keks-teig" data-teig/><path class="kan__keks-abdruck" data-abdruck/>'
      + '<path class="kan__keks-frei" data-frei/>'
      + '<line class="kan__keks-hilfe" data-hilfe="x"/><line class="kan__keks-hilfe" data-hilfe="y"/>'
      + '<g class="kan__keks-text" data-textgruppe tabindex="0" role="button" aria-label="Text verschieben">'
      + '<path class="kan__keks-huelle" data-huelle/><path class="kan__keks-schrift" data-schrift/>'
      + `${griff(-1)}${griff(1)}</g></g>`;
    this.inhalt = svg.querySelector('[data-keks-inhalt]');
    this.gruppe = svg.querySelector('[data-textgruppe]');
    svg.addEventListener('pointerdown', (e) => this.runter(e));
    svg.addEventListener('pointermove', (e) => this.bewegen(e));
    svg.addEventListener('pointerup', (e) => this.hoch(e));
    svg.addEventListener('pointercancel', (e) => this.hoch(e));
    this.gruppe.addEventListener('keydown', (e) => {
      const schritt = { ArrowLeft: [1, 0], ArrowRight: [-1, 0], ArrowUp: [0, 1], ArrowDown: [0, -1] }[e.key];
      if (!schritt || !this.lage) return;
      e.preventDefault();
      this.tun.ziehen(this.lage.x + schritt[0], this.lage.y + schritt[1], false);
    });
    new ResizeObserver(() => this.griffeSetzen()).observe(svg);
  }

  setzen(a) {
    const teig = a.umriss || [];
    this.svg.querySelector('[data-teig]').setAttribute('d', pfad(teig));
    this.svg.querySelector('[data-abdruck]').setAttribute('d', pfad((a.teile && (a.art === 'stempel'
      ? a.teile.relief : a.teile.rippen)) || []));
    this.svg.querySelector('[data-frei]').setAttribute('d', pfad(a.frei || []));
    // Rahmen des Ausstechers in Grundriss-Koordinaten: seine Mitte für die Mittellinien, mit 4 mm Rand als Bildausschnitt
    let x0 = Infinity; let y0 = Infinity; let x1 = -Infinity; let y1 = -Infinity;
    teig.forEach(([r]) => {
      for (let i = 0; i < r.length; i += 2) {
        x0 = Math.min(x0, r[i]); x1 = Math.max(x1, r[i]); y0 = Math.min(y0, r[i + 1]); y1 = Math.max(y1, r[i + 1]);
      }
    });
    if (!(x0 < x1)) return;
    this.mitte = { x: (x0 + x1) / 2, y: (y0 + y1) / 2 };
    const linie = (achse, attr) => Object.entries(attr).forEach(([k, v]) => this.svg.querySelector(`[data-hilfe="${achse}"]`).setAttribute(k, v));
    linie('x', { x1: this.mitte.x, x2: this.mitte.x, y1: y0 - 3, y2: y1 + 3 });
    linie('y', { y1: this.mitte.y, y2: this.mitte.y, x1: x0 - 3, x2: x1 + 3 });
    this.svg.setAttribute('viewBox', `${-x1 - 4} ${-y1 - 4} ${x1 - x0 + 8} ${y1 - y0 + 8}`);
    this.griffeSetzen();
  }

  textSetzen(t) {
    this.svg.querySelector('[data-schrift]').setAttribute('d', t ? pfad(t.teile) : '');
    this.svg.querySelector('[data-huelle]').setAttribute('d', t ? pfad([[t.huelle]]) : '');
    this.mitText = Boolean(t);                      // display statt hidden: SVG-Elemente kennen hidden nicht
    this.gruppe.style.display = t ? '' : 'none';
    this.svg.classList.toggle('kan__keks--mit-text', this.mitText);
    this.breite = t ? t.breite : 0;
    this.griffeSetzen();
  }

  /* Die Drehgriffe gleich groß auf dem Bildschirm, gleich weit neben dem Text: Kreis 11 px, Fläche zum Antippen 18 px
     Radius — am Touchscreen 15 und 24 px (48 px zum Antippen) */
  griffeSetzen() {
    const m = this.inhalt.getScreenCTM();
    if (!m || !this.mitText) return;
    const mmJePx = 1 / Math.hypot(m.a, m.b);
    this.mmJePx = mmJePx;
    const grob = matchMedia('(pointer: coarse)').matches;
    const r = (grob ? 24 : 18) * mmJePx;
    this.svg.querySelectorAll('[data-dreh]').forEach((g) => {
      const x = Number(g.dataset.dreh) * (this.breite / 2 + (grob ? 26 : 20) * mmJePx);
      g.setAttribute('transform', `translate(${x} 0) scale(${r})`);
    });
  }

  lageSetzen(x, y, w, passt) {
    this.lage = { x, y };
    this.winkel = w;
    this.gruppe.setAttribute('transform', `translate(${x} ${y}) rotate(${w})`);
    this.svg.classList.toggle('kan__keks--passt-nicht', !passt);
  }

  /* Mittellinien: während des Ziehens zu sehen, kräftig, wenn der Text auf ihnen sitzt */
  hilfe(x, y) {
    this.svg.querySelector('[data-hilfe="x"]').classList.toggle('kan__keks-hilfe--trifft', x);
    this.svg.querySelector('[data-hilfe="y"]').classList.toggle('kan__keks-hilfe--trifft', y);
  }

  punkt(e) {
    const p = this.svg.createSVGPoint();
    p.x = e.clientX;
    p.y = e.clientY;
    return p.matrixTransform(this.inhalt.getScreenCTM().inverse());
  }

  runter(e) {
    if (!this.mitText || !this.lage) return;
    const p = this.punkt(e);
    this.svg.setPointerCapture(e.pointerId);
    if (e.target.closest('[data-dreh]')) {         // am Kreis: drehen um die Mitte des Textes
      this.modus = 'drehen';
      this.start = { a: grad(p.y - this.lage.y, p.x - this.lage.x), w: this.winkel };
      this.svg.classList.add('kan__keks--dreht');
      return;
    }
    // auf den Text: von dort aus ziehen; daneben: der Text springt mit der Mitte unter den Finger
    this.modus = 'ziehen';
    this.griff = e.target.closest('[data-textgruppe]') ? { x: p.x - this.lage.x, y: p.y - this.lage.y } : { x: 0, y: 0 };
    this.svg.classList.add('kan__keks--zieht');
    this.tun.ziehen(p.x - this.griff.x, p.y - this.griff.y);
  }

  bewegen(e) {
    if (!this.modus) return;
    const p = this.punkt(e);
    if (this.modus === 'drehen') this.tun.drehen(this.start.w + grad(p.y - this.lage.y, p.x - this.lage.x) - this.start.a);
    else this.tun.ziehen(p.x - this.griff.x, p.y - this.griff.y);
  }

  hoch(e) {
    if (!this.modus) return;
    this.modus = null;
    this.svg.classList.remove('kan__keks--zieht', 'kan__keks--dreht');
    this.hilfe(false, false);
    if (this.svg.hasPointerCapture(e.pointerId)) this.svg.releasePointerCapture(e.pointerId);
    this.tun.los();
  }
}

class KeksAnpassen extends HTMLElement {
  connectedCallback() {
    if (this.laeuft) return;
    this.laeuft = true;
    const d = this.dataset;
    this.$ = (sel) => this.querySelector(sel);
    this.api = (d.api || 'https://produktion.cookiehaus.de').replace(/\/$/, '');
    this.varianten = { allinone: d.variante, stempel: d.varianteStempel || '' };
    // Sonderanfertigung: dieselbe Variante, die Ausführung als Eigenschaft; gesperrt/bestellt kommen vom Server
    this.stempelEigenschaft = 'stempelEigenschaft' in d;
    this.gesperrt = [];
    this.bestellt = '';
    this.preise = {
      allinone: { cent: Number(d.cent), vorher: d.vorher },
      stempel: { cent: Number(d.centStempel), vorher: d.vorherStempel },
    };
    this.aufpreis = Number(d.aufpreisCent) || 0;
    this.geld = new Intl.NumberFormat('de-DE', { style: 'currency', currency: d.waehrung || 'EUR' });
    // Vom Produkt aus gilt All-in-One (Größe, Höhe und Stempeltiefe gehen nur dort); ?a=stempel öffnet die andere
    this.art = new URLSearchParams(location.search).get('a') === 'stempel' && this.varianten.stempel ? 'stempel' : 'allinone';
    this.antworten = new Map();
    this.textAntworten = new Map();
    this.schrift = 'klar';
    this.schriftNamen = { klar: 'Klar' };
    this.g = SCHRIFT.standard;
    this.lage = null;                                 // Mitte des Textes in mm (Grundriss-Koordinaten)
    this.winkel = 0;                                  // Drehung des Textes in Grad, im Uhrzeigersinn wie auf dem Keks
    this.ansicht = '3d';
    this.bauen();
    this.buehne = new Buehne(this.$('[data-flaeche]'));
    // Ohne WebGL 2 (three.js 0.169: Safari ab iOS 15) oder ohne jsDelivr: die Keks-Ansicht kann alles außer Drehen im
    // Raum. In Apps (Instagram, Facebook, TikTok) dazu der Weg in den richtigen Browser.
    this.buehne.bereit.catch(() => {
      this.$('[data-flaeche]').classList.add('kan__flaeche--ohne3d');
      if (/Instagram|FBAN|FBAV|FB_IAB|musical_ly|TikTok|Snapchat/i.test(navigator.userAgent)) {
        this.$('.kan__ohne3d').textContent = 'In dieser App lädt die 3D-Ansicht nicht. In der Keks-Ansicht geht alles – '
          + 'für 3D die Seite über ••• im Browser öffnen.';
      }
      this.ansichtSetzen('keks');
    });
    this.keks = new KeksAnsicht(this.$('[data-keks]'), {
      ziehen: (x, y, rasten = true) => this.textZiehen(x, y, rasten),
      drehen: (w) => this.textDrehen(w),
      los: () => this.standZeigen(),
    });
    this.starten();
    this.schriftenLaden();
  }

  bauen() {
    const kopf = this.$('[data-kopf]');
    const fuss = this.$('[data-fuss]');
    const info = this.$('[data-info]');
    const raster = el('div', 'kan__raster');
    raster.innerHTML = VORLAGE;
    if (kopf) raster.prepend(kopf);
    this.prepend(raster);
    const rechts = raster.querySelector('[data-rechts]');
    if (fuss) rechts.querySelector('.kan__links').before(fuss);   // wie auf der Produktseite: direkt unter dem Kaufknopf
    if (info) rechts.append(info);
    const d = this.dataset;
    this.$('[data-zurueck]').href = d.url || '/';
    this.$('[data-hinweis-text]').textContent = d.hinweisText || '';
    this.$('[data-hinweis-text]').hidden = !d.hinweisText;
    this.$('[data-hinweis-groesse]').textContent = d.hinweisGroesse || '';
    if (this.varianten.stempel) this.$('[data-art]').hidden = false;
    this.$(`[data-art] input[value="${this.art}"]`).checked = true;
    this.$('[data-art]').addEventListener('change', (e) => this.artSetzen(e.target.value));
    this.$('[data-kaufen]').addEventListener('click', () => this.kaufen());
    this.$('[data-zuruecksetzen]').addEventListener('click', () => this.zuruecksetzen());
    this.querySelectorAll('[data-ansicht]').forEach((k) => k.addEventListener('click', () => this.ansichtSetzen(k.dataset.ansicht)));
    const feld = this.$('[data-text]');
    feld.maxLength = ZEILEN * (ZEICHEN + 1);
    feld.addEventListener('input', () => {
      this.gekappt = this.kappen();
      feld.rows = Math.min(Math.max(feld.value.split('\n').length, 1), ZEILEN);
      this.textGeaendert();
    });
    // wer schreibt, will sehen, wo der Text im Keks liegt
    feld.addEventListener('focus', () => { if (feld.value.trim()) this.ansichtSetzen('keks'); });
    // Am Handy beim Tippen (wie Name & Text): Bühne kompakt, das Feld direkt darunter — sonst liegt es mit offener
    // Tastatur unter der angehefteten Bühne. Groß wird sie erst 300 ms nach dem Tippen, sonst verrutscht, was man antippt.
    const handy = matchMedia('(max-width: 989px)');
    feld.addEventListener('focus', () => {
      if (!handy.matches) return;
      clearTimeout(this.tippUhr);
      this.classList.add('kan--tippt');
      requestAnimationFrame(() => {
        const buehne = this.$('.kan__buehne');
        feld.style.scrollMarginTop = `${Math.round(parseFloat(getComputedStyle(buehne).top) + buehne.offsetHeight + 8)}px`;
        feld.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
    feld.addEventListener('blur', () => {
      this.tippUhr = setTimeout(() => this.classList.remove('kan--tippt'), 300);
    });
    this.regler('g').addEventListener('input', () => {
      this.g = Number(this.regler('g').value);
      this.textGeaendert();
    });
    this.$('[data-aus="g"]').textContent = `${this.g} mm`;
    this.preisZeigen();
  }

  regler(n) {
    return this.$(`[data-regler="${n}"]`);
  }

  ansichtSetzen(ansicht) {
    this.ansicht = ansicht;
    const keks = ansicht === 'keks';
    this.querySelectorAll('[data-ansicht]').forEach((k) => k.setAttribute('aria-selected', String(k.dataset.ansicht === ansicht)));
    this.$('[data-keks]').toggleAttribute('hidden', !keks);   // SVG kennt die Eigenschaft hidden nicht, nur das Attribut
    this.$('[data-flaeche]').classList.toggle('kan__flaeche--keks', keks);
    this.tippZeigen();
  }

  tippZeigen() {
    const tipp = this.$('[data-tipp]');
    const text = Boolean(this.textAntwort);
    tipp.textContent = this.ansicht === 'keks'
      ? (text ? 'Text ziehen, an den Kreisen drehen' : 'So drückt er sich im Keks ab')
      : (text ? 'Auf dem Ausstecher steht dein Text spiegelverkehrt' : 'Ziehen zum Drehen');
    this.$('[data-flaeche]').classList.toggle('kan__flaeche--tipp', this.ansicht === 'keks' || text);
  }

  async holen(was, werte, signal) {
    const q = new URLSearchParams({ v: STAND, sku: this.dataset.sku, ...werte });
    try {
      const r = await fetch(`${this.api}/anpassen/${was}?${q}`, { signal });
      const j = await r.json();
      if (r.status === 503) j.voll = true;          // rechnet gerade (Grenzen eines feinen Motivs ~15 s): nachfragen
      return j;
    } catch (e) {
      if (e.name === 'AbortError') throw e;
      return { ok: false, fehler: 'Die Vorschau ist gerade nicht erreichbar. Bitte lade die Seite gleich noch einmal.' };
    }
  }

  async starten() {
    this.laedt(true);
    let a = await this.holen('modell', { a: this.art });
    for (let i = 0; a.voll && i < 20; i++) {
      await new Promise((r) => setTimeout(r, 2000));
      a = await this.holen('modell', { a: this.art });
    }
    this.laedt(false);
    if (!a.ok) {
      this.classList.add('kan--nicht');
      this.pruefungZeigen(a.fehler);
      return;
    }
    this.std = a.standard;
    this.grenzwerte = a.regler;
    this.q = (a.standard.kurz - 2 * RAND) / (a.standard.laenge - 2 * RAND);
    this.w = { l: a.laenge, h: a.standard.hoehe, t: a.standard.tiefe, ring: a.standard.ring };
    this.antworten.set(`${a.art}|${a.laenge}`, a);
    this.gesperrt = a.gesperrt || [];
    this.bestellt = a.bestellt || '';
    this.reglerEinrichten();
    this.artWahlZeigen();
    this.spanneZeigen();
    // als Stempel bestellte Sonderanfertigung: gleich als Stempel zeigen, ohne die Wahl im Browser zu merken
    if (this.gesperrt.includes(this.art)) this.artSetzen(this.art === 'stempel' ? 'allinone' : 'stempel', false);
    else this.zeigen(a);
    // Grenzen dauern bei feinen Motiven ein paar Sekunden: das Modell steht schon
    const grenzen = (versuch = 0) => this.holen('grenzen', {}).then((g) => {
      if (g.voll && versuch < 20) setTimeout(() => grenzen(versuch + 1), 3000);
      if (g.ok === false) return;
      this.grenzen = g;
      this.spanneZeigen();
      this.pruefungZeigen();
    });
    grenzen();
  }

  kurz(l) {
    return Math.round(((l - 2 * RAND) * this.q + 2 * RAND) * 10) / 10;
  }

  reglerEinrichten() {
    const [lmin, lmax] = this.grenzwerte.laenge;
    Object.assign(this.regler('l'), { min: lmin, max: lmax, step: 1 });
    // Ein Schritt der kürzesten Seite ist ein Millimeter der längsten: beide Regler stehen immer auf demselben Maß
    Object.assign(this.regler('k'), { min: this.kurz(lmin), max: this.kurz(lmax), step: this.q });
    this.regler('l').addEventListener('input', () => this.groesseSetzen(Number(this.regler('l').value)));
    this.regler('k').addEventListener('input', () => {
      this.groesseSetzen(Math.round((Number(this.regler('k').value) - 2 * RAND) / this.q + 2 * RAND));
    });
    this.regler('h').addEventListener('input', () => {
      this.w[this.art === 'stempel' ? 'ring' : 'h'] = Number(this.regler('h').value);
      this.hoeheSetzen();
    });
    this.regler('t').addEventListener('input', () => {
      this.w.t = Number(this.regler('t').value);
      this.hoeheSetzen();
    });
    this.artRegler();
    this.groesseSetzen(this.w.l, true);
  }

  /* Schneidhöhe: All-in-One 1–3 cm; Stempel & Ausstecher: Höhe des Rings ab 1,5 cm. Stempeltiefe: die Prägerippen
     bleiben mindestens rippe_min hoch und liegen mindestens tiefe_min hinter der Schneide. */
  artRegler() {
    const stempel = this.art === 'stempel';
    const [hmin, hmax] = stempel ? this.grenzwerte.ring : this.grenzwerte.hoehe;
    Object.assign(this.regler('h'), { min: hmin, max: hmax, value: stempel ? this.w.ring : this.w.h });
    this.querySelectorAll('[data-nur]').forEach((e) => { e.hidden = e.dataset.nur !== this.art; });
    this.hoeheSetzen();
  }

  /* Ausführung: die gesperrte grau, darunter warum — und bei einem All-in-One, dass es auch als Stempel geht */
  artWahlZeigen() {
    const feld = this.$('[data-art]');
    feld.hidden = !this.varianten.stempel;
    feld.querySelectorAll('input').forEach((i) => {
      i.disabled = this.gesperrt.includes(i.value);
      i.closest('label').classList.toggle('kan__pille--aus', i.disabled);
    });
    const h = this.$('[data-art-hinweis]');
    h.textContent = {
      stempel: 'All-in-One geht hier nicht: Dein Motiv ist als Stempel & Ausstecher gezeichnet, so fein wie möglich. '
        + 'Als All-in-One müssten wir es vereinfachen.',
      allinone: 'Als All-in-One wird ein Motiv oft vereinfacht gezeichnet. Aus deinem All-in-One machen wir dir aber '
        + 'gern auch einen Stempel & Ausstecher.',
    }[this.bestellt] || '';
    h.hidden = !h.textContent;
  }

  hoeheSetzen() {
    const g = this.grenzwerte;
    const tmax = this.w.h - g.rippe_min;
    this.w.t = Math.min(Math.max(this.w.t, g.tiefe_min), tmax);
    Object.assign(this.regler('t'), { min: g.tiefe_min, max: tmax, value: this.w.t });
    const stempel = this.art === 'stempel';
    const h = stempel ? this.w.ring : this.w.h;
    this.$('[data-aus="h"]').textContent = cm(h);
    this.$('[data-aus="t"]').textContent = `${this.w.t} mm`;
    this.$('[data-hinweis="h"]').textContent = stempel
      ? `Höhe des Rings. Standard ${cm(this.std.ring)}.`
      : `So tief schneidet der Ausstecher. Standard ${cm(this.std.hoehe)}, höher für dicken Teig.`;
    this.$('[data-hinweis="t"]').textContent = `Abstand der Prägung zur Schneide: der Stempel prägt ab ${this.w.t} mm `
      + `Teigdicke. Standard ${this.std.tiefe} mm.`;
    this.buehne.bereit.then(() => {
      this.buehne.hoehen(this.w);
      this.buehne.einpassen();
    }).catch(() => {});
    this.masseZeigen();
    this.pruefungZeigen();
  }

  groesseSetzen(l, ohneLaden) {
    const [lmin, lmax] = this.grenzwerte.laenge;
    this.w.l = Math.min(Math.max(Math.round(l) || lmin, lmin), lmax);
    this.regler('l').value = this.w.l;
    this.regler('k').value = this.kurz(this.w.l);
    this.$('[data-aus="l"]').textContent = cm(this.w.l);
    this.$('[data-aus="k"]').textContent = cm(this.kurz(this.w.l));
    const a = this.antwort;
    if (a && this.buehne.T) this.buehne.skalieren((this.w.l - 2 * RAND) / (a.laenge - 2 * RAND));
    this.masseZeigen();
    this.pruefungZeigen();
    if (!ohneLaden) this.planen();
  }

  artSetzen(art, gewaehlt = true) {
    if (this.gesperrt.includes(art)) return;
    this.art = art;
    this.$(`[data-art] input[value="${art}"]`).checked = true;
    if (!this.w) return;                              // vor der ersten Antwort: starten() nimmt die Wahl mit
    if (gewaehlt) window.keksAusfuehrung?.merken(NAME[art]);
    this.artRegler();
    this.spanneZeigen();
    this.preisZeigen();
    this.planen(0);
  }

  zuruecksetzen() {
    if (!this.w) return;
    this.w = { l: this.std.laenge, h: this.std.hoehe, t: this.std.tiefe, ring: this.std.ring };
    this.$('[data-text]').value = '';
    this.letzterText = '';
    this.winkel = 0;
    this.textGeaendert();
    this.artRegler();
    this.groesseSetzen(this.w.l);
  }

  planen(warten = 180) {
    clearTimeout(this.uhr);
    this.knopf();
    this.uhr = setTimeout(() => this.laden(), warten);
  }

  async laden() {
    const art = this.art;
    const l = this.w.l;
    const schluessel = `${art}|${l}`;
    this.schluessel = schluessel;
    let a = this.antworten.get(schluessel);
    if (!a) {
      this.abbruch?.abort();
      this.abbruch = new AbortController();
      this.laedt(true);
      try {
        a = await this.holen('modell', { l, a: art }, this.abbruch.signal);
      } catch (_) {
        return;                                       // abgebrochen: eine neuere Anfrage läuft
      }
      if (a.voll) {                                   // nachfragen, solange nichts anderes gewählt wird
        this.uhr = setTimeout(() => this.laden(), 2000);
        return;
      }
      if (a.ok) this.antworten.set(schluessel, a);
    }
    if (schluessel !== this.schluessel) return;
    this.laedt(false);
    if (!a.ok) {
      this.pruefungZeigen(a.fehler);
      return;
    }
    this.zeigen(a);
  }

  zeigen(a) {
    const vorher = this.antwort;
    this.antwort = a;
    // Text mitnehmen: bei anderer Größe rückt er im selben Verhältnis zur Mitte, seine Schrift bleibt gleich groß
    if (this.lage && vorher && vorher.laenge !== a.laenge) {
      const f = (a.laenge - 2 * RAND) / (vorher.laenge - 2 * RAND);
      this.lage = { x: this.lage.x * f, y: this.lage.y * f };
    }
    this.keks.setzen(a);
    this.minSetzen();
    this.platzZeigen();
    this.dreiD();
    this.textEinpassen();
    this.masseZeigen();
    this.pruefungZeigen();
  }

  /* 3D: mit Text das Modell, das der Server samt Text gerechnet hat (Prägung, Supportlinien, Stege wie gedruckt); bis es
     da ist, das Modell ohne Text und der Text als eigenes Prisma. Neu gebaut wird nur, wenn sich das Modell ändert. */
  dreiD() {
    const tm = this.textModell;
    const mitText = Boolean(tm && tm.antwort && tm.schluessel === this.textSchluessel);
    const a = mitText ? tm.antwort : this.antwort;
    if (!a || !a.teile) return;
    this.buehne.bereit.then(() => {
      if (this.buehne.gezeigtes !== a) {
        this.buehne.setzen(a);
        this.buehne.gezeigtes = a;
        this.buehne.hoehen(this.w);
        this.buehne.einpassen(!this.buehne.gezeigt);
      }
      this.buehne.textSichtbar(!mitText);
    }).catch(() => {});
  }

  get passend() {
    const a = this.antwort;
    return Boolean(a && a.art === this.art && a.laenge === this.w.l);
  }

  laedt(an) {
    this.$('[data-laedt]').hidden = !an;
    this.classList.toggle('kan--laedt', an);
  }

  masseZeigen() {
    const stempel = this.art === 'stempel';
    const h = stempel ? this.w.ring : this.w.h;
    this.$('[data-masse]').textContent = `${zahl(this.w.l)} × ${zahl(this.kurz(this.w.l))} cm · ${zahl(h)} cm hoch`
      + (stempel ? ' · Ring und Stempel' : ` · prägt ab ${this.w.t} mm Teig`);
    this.preisZeigen();
  }

  /* Wo die gewählte Ausführung geht: grüner Bereich unter den Größenreglern */
  spanneZeigen() {
    const g = this.grenzen && this.grenzen[this.art];
    const [lmin, lmax] = this.grenzwerte.laenge;
    const balken = this.$('[data-spanne]');
    const text = this.$('[data-spanne-text]');
    if (!this.grenzen) {
      text.textContent = 'Passende Größen werden berechnet …';
      return;
    }
    if (!g) {
      balken.style.cssText = 'left:0;right:100%';
      text.textContent = `${NAME[this.art]} geht bei diesem Motiv nicht.`;
      return;
    }
    const anteil = (mm) => `${(100 * (mm - lmin)) / (lmax - lmin)}%`;
    balken.style.left = anteil(g.min);
    balken.style.right = `${100 - parseFloat(anteil(g.max))}%`;
    text.textContent = `${NAME[this.art]} geht von ${cm(g.min)} bis ${cm(g.max)} (längste Seite).`;
  }

  /* ---------------------------------------------------------------- Eigener Text */

  /* Schriften von Name & Text, je mit Muster; ohne Antwort bleibt „Klar“ */
  async schriftenLaden() {
    let o;
    try {
      o = await (await fetch(`${this.api}/text/optionen?v=${TEXT_STAND}`)).json();
    } catch (_) {
      return;
    }
    const ziel = this.$('[data-schriften]');
    ziel.replaceChildren();
    o.schriften.forEach((x) => {
      this.schriftNamen[x.key] = x.name;
      const label = el('label', 'kan__schrift');
      const eingabe = el('input');
      Object.assign(eingabe, { type: 'radio', name: 'kan-schrift', value: x.key, checked: x.key === this.schrift });
      eingabe.addEventListener('change', () => {
        this.schrift = x.key;
        // Markierung per Klasse statt :has() — das kennt Safari erst ab iOS 15.4 (In-App-Browser älterer iPhones)
        ziel.querySelectorAll('.kan__schrift').forEach((l) => l.classList.toggle('kan__schrift--an', l === label));
        this.minSetzen();
        this.textGeaendert();
      });
      label.classList.toggle('kan__schrift--an', x.key === this.schrift);
      const muster = el('span', 'kan__muster');
      muster.setAttribute('aria-hidden', 'true');
      muster.style.setProperty('--kan-bild', `url("${svgUrl(x.muster)}")`);
      label.append(eingabe, muster, el('span', '', x.name));
      ziel.append(label);
    });
  }

  /* Platz für Text in diesem Ausstecher und dieser Schrift (anpassen._textplatz): Zeichen je Zeile, Zeilen und die
     kleinste Schrifthöhe, die lesbar bleibt */
  get platz() {
    const p = this.antwort && this.antwort.textplatz && this.antwort.textplatz[this.schrift];
    return p || { min: SCHRIFT.min, zeichen: ZEICHEN, zeilen: ZEILEN };
  }

  passtInPlatz(wert) {
    const p = this.platz;
    const zeilen = wert.split('\n');
    return zeilen.length <= p.zeilen && zeilen.every((z) => z.length <= p.zeichen);
  }

  /* Beim Tippen: mehr als Platz ist, kommt nicht an (die Eingabe davor bleibt); Eingefügtes wird abgeschnitten */
  kappen() {
    const feld = this.$('[data-text]');
    const p = this.platz;
    let gekappt = false;
    if (!this.passtInPlatz(feld.value)) {
      gekappt = true;
      const vorher = this.letzterText || '';
      if (this.passtInPlatz(vorher) && feld.value.length - vorher.length <= 2) {
        const pos = Math.max(0, feld.selectionStart - (feld.value.length - vorher.length));
        feld.value = vorher;
        feld.setSelectionRange(pos, pos);
      } else {
        feld.value = feld.value.split('\n').slice(0, p.zeilen).map((z) => z.slice(0, p.zeichen)).join('\n');
      }
    }
    this.letzterText = feld.value;
    return gekappt;
  }

  /* Schrifthöhe nie unter die kleinste lesbare der Schrift */
  minSetzen() {
    const r = this.regler('g');
    r.min = this.platz.min;
    if (this.g < this.platz.min) this.g = this.platz.min;
    r.value = this.g;
    this.$('[data-aus="g"]').textContent = `${this.g} mm`;
  }

  get zuLang() {
    return Boolean(this.textWert) && !this.passtInPlatz(this.$('[data-text]').value);
  }

  platzZeigen() {
    const p = this.platz;
    const z = this.$('[data-platz]');
    const zeilen = p.zeilen === 1 ? 'eine Zeile' : `${p.zeilen} Zeilen`;
    z.classList.toggle('kan__fein', Boolean(this.gekappt) && !this.zuLang);
    z.classList.toggle('kan__fehltext', this.zuLang);
    z.textContent = this.zuLang
      ? `Für diese Größe und Schrift zu lang: höchstens ${p.zeichen} Zeichen je Zeile, ${zeilen}. Kürze den Text oder `
        + 'mach den Ausstecher größer.'
      : `${this.gekappt ? 'Mehr bleibt hier nicht lesbar: ' : 'Platz für '}bis ${p.zeichen} Zeichen je Zeile, ${zeilen}.`;
    this.knopf();
  }

  get textWert() {
    return this.$('[data-text]').value.split('\n').map((z) => z.replace(/\s+/g, ' ').trim()).join('\n').trim();
  }

  textGeaendert() {
    const t = this.textWert;
    this.$('[data-textmehr]').hidden = !t;
    this.$('[data-aus="g"]').textContent = `${this.g} mm`;
    this.platzZeigen();
    clearTimeout(this.textUhr);
    if (!t) {
      this.textAbbruch?.abort();
      this.textAntwort = null;
      this.textFehler = '';
      this.textZeigen();
      return;
    }
    if (this.ansicht !== 'keks') this.ansichtSetzen('keks');
    this.textOffen = `${t}|${this.schrift}|${this.g}`;
    this.knopf();
    this.textUhr = setTimeout(() => this.textLaden(t, this.schrift, this.g), 250);
  }

  async textLaden(t, s, g) {
    const schluessel = `${t}|${s}|${g}`;
    let a = this.textAntworten.get(schluessel);
    if (!a) {
      this.textAbbruch?.abort();
      this.textAbbruch = new AbortController();
      try {
        const r = await fetch(`${this.api}/anpassen/text?${new URLSearchParams({ v: STAND, t, s, g })}`,
          { signal: this.textAbbruch.signal });
        a = await r.json();
      } catch (e) {
        if (e.name === 'AbortError') return;
        a = { ok: false, fehler: 'Die Textvorschau ist gerade nicht erreichbar.' };
      }
      if (a.ok) this.textAntworten.set(schluessel, a);
    }
    if (schluessel !== this.textOffen) return;
    this.textOffen = '';
    if (!a.ok) {
      this.textFehler = a.fehler;
      this.textZeigen();
      return;
    }
    this.textFehler = '';
    this.textAntwort = a;
    this.textZeigen();
  }

  /* Text in Bühne und Keks-Ansicht, Lage prüfen, Stand unter dem Feld */
  textZeigen() {
    const a = this.textAntwort;
    this.keks.textSetzen(a);
    this.buehne.bereit.then(() => this.buehne.textSetzen(a && a.teile)).catch(() => {});
    if (a) this.textEinpassen();
    else this.textModellPlanen();
    this.standZeigen();
    this.tippZeigen();
    this.preisZeigen();
  }

  /* Unter dem Feld: Maße, ob er passt, Drehung, Teig-Test */
  standZeigen() {
    const a = this.textAntwort;
    const stand = this.$('[data-textstand]');
    stand.replaceChildren();
    if (this.textFehler) {
      stand.append(el('p', 'kan__klein kan__fehltext', this.textFehler));
    } else if (a) {
      const zeile = el('p', 'kan__klein', `${zahl(a.breite)} × ${zahl(a.hoehe)} cm, ${this.passt === false
        ? 'passt so nicht in den Ausstecher' : 'verschiebbar in der Keks-Ansicht'}${this.winkel
        ? `, um ${Math.abs(this.winkel)}° ${this.winkel > 0 ? 'nach rechts' : 'nach links'} gedreht` : ''}`);
      if (this.winkel) {
        const k = el('button', 'kan__link', 'Gerade stellen');
        k.type = 'button';
        k.addEventListener('click', () => this.textDrehen(0));
        zeile.append(' ', k);
      }
      stand.append(zeile);
      const tm = this.textModell;
      const fertig = tm && tm.schluessel === this.textSchluessel;
      if (fertig && tm.fehler) stand.append(el('p', 'kan__klein kan__fehltext', tm.fehler));
      else if (this.passt !== false && !this.zuLang) {
        stand.append(el('p', 'kan__klein', fertig ? (this.art === 'stempel' ? 'Druckdatei mit Text gerechnet ✓'
          : 'Druckdatei mit Text gerechnet, Supportlinien gesetzt ✓') : 'Druckdatei mit Text wird gerechnet …'));
      }
      if (this.passt === false) {
        stand.append(el('p', 'kan__klein kan__fehltext', 'Der Text ist größer als die Fläche im Ausstecher. Stell die '
          + 'Schrift kleiner oder kürze ihn.'));
      }
      if (a.grund) {
        const p = el('p', 'kan__klein kan__fein', `${a.grund}${a.lesbar_ab ? ` Ab ${a.lesbar_ab} mm Schrifthöhe bleibt `
          + 'er lesbar.' : ''}`);
        if (a.lesbar_ab) {
          const k = el('button', 'kan__link', `Auf ${a.lesbar_ab} mm stellen`);
          k.type = 'button';
          k.addEventListener('click', () => {
            this.g = a.lesbar_ab;
            this.regler('g').value = this.g;
            this.textGeaendert();
          });
          p.append(' ', k);
        }
        stand.append(p);
      }
    }
  }

  /* Passt die Hülle des Textes mit der Mitte auf x, y ganz in die freie Fläche? Geprüft an ihren Ecken und alle 1 mm
     auf den Kanten (die Fläche kann eingebuchtet sein, die Hülle nicht). */
  passtBei(x, y, w = this.winkel) {
    const a = this.antwort;
    const t = this.textAntwort;
    if (!a || !a.frei || !t) return false;
    const c = Math.cos((w * Math.PI) / 180);
    const sn = Math.sin((w * Math.PI) / 180);
    const h = [];                                     // die Hülle gedreht wie rotate(w) der Keks-Ansicht
    for (let i = 0; i < t.huelle.length; i += 2) h.push(t.huelle[i] * c - t.huelle[i + 1] * sn, t.huelle[i] * sn + t.huelle[i + 1] * c);
    for (let i = 0; i < h.length; i += 2) {           // erst die Ecken: so scheitern die meisten Stellen schnell
      if (!inFlaeche(x + h[i], y + h[i + 1], a.frei)) return false;
    }
    for (let i = 0; i < h.length; i += 2) {
      const j = (i + 2) % h.length;
      const n = Math.max(1, Math.ceil(Math.hypot(h[j] - h[i], h[j + 1] - h[i + 1])));
      for (let k = 0; k < n; k++) {
        if (!inFlaeche(x + h[i] + ((h[j] - h[i]) * k) / n, y + h[i + 1] + ((h[j + 1] - h[i + 1]) * k) / n, a.frei)) return false;
      }
    }
    return true;
  }

  /* Neue Schrift, Größe oder Ausführung: bleibt der Text, wo er ist? Sonst die nächste Stelle, an der er ganz passt
     (in Ringen um seine Lage, 2 mm Raster), zuerst die Mitte der Fläche, wenn er noch nie lag. */
  textEinpassen() {
    const a = this.antwort;
    const t = this.textAntwort;
    if (!a || !t || !a.frei) {
      this.knopf();
      return;
    }
    const start = this.lage || { x: a.mitte[0], y: a.mitte[1] };
    let ziel = this.passtBei(start.x, start.y) ? start : null;
    const weit = Math.max(a.breite || 0, a.hoehe || 0);
    const zuGross = t.breite > weit || t.hoehe > weit;  // größer als der Ausstecher: gar nicht erst suchen
    if (!ziel && !this.lage && this.passtBei(a.mitte[0], a.mitte[1])) ziel = { x: a.mitte[0], y: a.mitte[1] };
    for (let r = 2; !ziel && !zuGross && r <= weit; r += 2) {
      const n = Math.ceil((2 * Math.PI * r) / 2);
      for (let i = 0; i < n && !ziel; i++) {
        const x = start.x + r * Math.cos((2 * Math.PI * i) / n);
        const y = start.y + r * Math.sin((2 * Math.PI * i) / n);
        if (this.passtBei(x, y)) ziel = { x, y };
      }
    }
    this.passt = Boolean(ziel);
    this.lageSetzen(ziel || start);
  }

  /* Ziehen in der Keks-Ansicht: nahe der Mittellinien des Ausstechers rastet er ein (waagerecht und senkrecht
     getrennt), am Rand der Fläche gleitet er entlang statt stehen zu bleiben. Pfeiltasten rasten nicht. */
  textZiehen(x, y, rasten = true) {
    if (!this.textAntwort || !this.lage) return;
    const m = this.keks.mitte;
    const nah = RASTEN_PX * (this.keks.mmJePx || 0.2);
    if (m && rasten && Math.abs(x - m.x) < nah) x = m.x;
    if (m && rasten && Math.abs(y - m.y) < nah) y = m.y;
    const alt = this.lage;
    const ziel = [{ x, y }, { x, y: alt.y }, { x: alt.x, y }].find((p) => this.passtBei(p.x, p.y));
    if (ziel) {
      this.passt = true;
      this.lageSetzen(ziel);
    }
    if (m) this.keks.hilfe(Math.abs(this.lage.x - m.x) < 0.06, Math.abs(this.lage.y - m.y) < 0.06);
  }

  /* Drehen an den Kreisen: ganze Grad, nahe 0°, 45°, 90° … rastet er ein; passt er gedreht nicht, bleibt er stehen */
  textDrehen(w) {
    if (!this.textAntwort || !this.lage) return;
    let g = ((Math.round(w) % 360) + 540) % 360 - 180;
    const raster = Math.round(g / 45) * 45;
    if (Math.abs(g - raster) <= RASTEN_GRAD) g = raster === -180 ? 180 : raster;
    if (g === this.winkel || !this.passtBei(this.lage.x, this.lage.y, g)) return;
    this.winkel = g;
    this.lageSetzen(this.lage);
    if (!this.keks.modus) this.standZeigen();
  }

  lageSetzen(p) {
    // ohne Runden in der Mitte des Ausstechers: dort soll er genau sitzen
    const m = this.keks.mitte || {};
    const r = (v, mv) => (Math.abs(v - mv) < 1e-6 ? v : Math.round(v * 10) / 10);
    this.lage = { x: r(p.x, m.x), y: r(p.y, m.y) };
    this.keks.lageSetzen(this.lage.x, this.lage.y, this.winkel, this.passt);
    this.buehne.bereit.then(() => this.buehne.textLage(this.lage.x, this.lage.y, this.winkel)).catch(() => {});
    this.textModellPlanen();
  }

  /* Was der Server für den Druck rechnet: Ausführung, Größe, Text, Schrift, Höhe, Lage, Drehung */
  get textSchluessel() {
    const t = this.textAntwort;
    if (!this.textWert || !t || !this.lage || !this.w) return '';
    return [this.art, this.w.l, t.t, t.s, t.g, this.lage.x, this.lage.y, this.winkel].join('|');
  }

  /* Modell samt Text anfragen, 0,4 s nachdem der Text zur Ruhe kam (Ziehen und Drehen fragen nicht bei jedem Schritt) */
  textModellPlanen() {
    clearTimeout(this.textModellUhr);
    const schluessel = this.textSchluessel;
    this.dreiD();
    this.knopf();
    if (!schluessel || !this.passend || this.passt === false || this.zuLang
        || (this.textModell && this.textModell.schluessel === schluessel)) return;
    this.textModellUhr = setTimeout(() => this.textModellLaden(schluessel), 400);
  }

  async textModellLaden(schluessel) {
    if (schluessel !== this.textSchluessel) return;
    const t = this.textAntwort;
    this.textModellAbbruch?.abort();
    this.textModellAbbruch = new AbortController();
    let a;
    try {
      a = await this.holen('modell', { l: this.w.l, a: this.art, t: t.t, s: t.s, g: t.g, x: this.lage.x,
        y: this.lage.y, w: this.winkel }, this.textModellAbbruch.signal);
    } catch (_) {
      return;                                         // abgebrochen: eine neuere Anfrage läuft
    }
    if (a.voll) {
      this.textModellUhr = setTimeout(() => this.textModellLaden(schluessel), 2000);
      return;
    }
    if (schluessel !== this.textSchluessel) return;
    this.textModell = { schluessel, antwort: a.ok && !a.text_fehler ? a : null,
      fehler: a.ok ? a.text_fehler || '' : a.fehler || 'Die Druckdatei ließ sich gerade nicht rechnen.' };
    this.dreiD();
    if (!this.keks.modus) this.standZeigen();
    this.knopf();
  }

  /* ---------------------------------------------------------------- Prüfung, Preis, Warenkorb */

  /* Weicht etwas vom Standard ab? Dann Aufpreis und keine Keks-Garantie. */
  get angepasst() {
    const w = this.w;
    const s = this.std;
    if (!w || !s) return Boolean(this.textWert);
    const anders = this.art === 'stempel' ? w.ring !== s.ring : (w.h !== s.hoehe || w.t !== s.tiefe);
    return Boolean(this.textWert) || w.l !== Math.round(s.laenge) || anders;
  }

  /* Das Ergebnis der Prüfung, bei „geht nicht“ mit dem Ausweg: andere Größe oder andere Ausführung */
  pruefungZeigen(fehler) {
    const box = this.$('[data-pruefung]');
    box.replaceChildren();
    this.knopf();
    if (fehler) {
      box.className = 'kan__pruefung kan__pruefung--nicht';
      box.append(el('p', '', fehler));
      return;
    }
    if (!this.passend) {
      box.className = 'kan__pruefung kan__pruefung--laedt';
      box.append(el('p', '', 'Wird geprüft …'));
      return;
    }
    const a = this.antwort;
    const l = this.w.l;
    if (a.stand === 'geht') {
      box.className = 'kan__pruefung kan__pruefung--gut';
      box.append(el('p', 'kan__titel', `Druckbar als ${NAME[a.art]}`), el('p', '', a.art === 'stempel'
        ? `${zahl(l)} × ${zahl(this.kurz(l))} cm, Ring ${cm(this.w.ring)} hoch, dazu der Stempel mit Griff.`
        : `${zahl(l)} × ${zahl(this.kurz(l))} cm, ${cm(this.w.h)} hoch, der Stempel prägt ab ${this.w.t} mm Teig.`));
      return;
    }
    box.className = 'kan__pruefung kan__pruefung--nicht';
    box.append(el('p', 'kan__titel', `So geht ${NAME[a.art]} nicht`));
    const liste = el('ul');
    a.gruende.forEach((g) => liste.append(el('li', '', g)));
    box.append(liste);
    const knopf = (text, tun) => {
      const k = el('button', 'kan__knopf', text);
      k.type = 'button';
      k.addEventListener('click', tun);
      box.append(k);
    };
    if (!this.grenzen) {
      box.append(el('p', 'kan__klein', 'Die passende Größe wird gerade gesucht …'));
      return;
    }
    const andere = a.art === 'stempel' ? 'allinone' : 'stempel';
    const ga = this.grenzen[andere];
    if (ga && !this.gesperrt.includes(andere) && (andere === 'allinone' || this.varianten.stempel)
        && l >= ga.min && l <= ga.max) {
      box.append(el('p', '', andere === 'stempel'
        ? 'So klein geht er nur noch als Stempel & Ausstecher, Ring und Stempel einzeln.'
        : 'Als All-in-One geht diese Größe.'));
      knopf(`${NAME[andere]} nehmen`, () => {
        this.$(`[data-art] input[value="${andere}"]`).checked = true;
        this.artSetzen(andere);
      });
    }
    const g = this.grenzen[a.art];
    if (g && (l < g.min || l > g.max)) {
      const ziel = l < g.min ? g.min : g.max;
      knopf(`${NAME[a.art]} in ${cm(ziel)}`, () => this.groesseSetzen(ziel));
    }
  }

  knopf() {
    const tm = this.textModell;
    const text = !this.textWert || (this.textAntwort && !this.textOffen && !this.textFehler && this.passt && !this.zuLang
      && tm && tm.antwort && tm.schluessel === this.textSchluessel);
    const ok = this.passend && this.antwort.stand === 'geht' && Boolean(this.varianten[this.art]) && text;
    this.$('[data-kaufen]').disabled = !ok;
    this.$('[data-hinweis-groesse]').classList.toggle('kan__garantie--an', Boolean(this.w && this.std
      && this.w.l !== Math.round(this.std.laenge)));
  }

  preisZeigen() {
    const p = this.preise[this.art];
    const betrag = this.$('.keks-preis__betrag');
    if (!betrag || !p || !p.cent) return;
    const auf = this.angepasst ? this.aufpreis : 0;
    betrag.textContent = this.geld.format((p.cent + auf) / 100);
    let vorher = this.$('.keks-preis__vorher');
    if (p.vorher && !auf && !vorher) {
      vorher = el('s', 'keks-preis__vorher');
      betrag.after(' ', vorher);
    }
    if (vorher) {
      vorher.textContent = auf ? '' : p.vorher || '';
      vorher.hidden = Boolean(auf) || !p.vorher;
    }
    let zusatz = this.$('[data-aufpreis]');
    if (!zusatz) {
      zusatz = el('span', 'kan__aufpreis');
      zusatz.dataset.aufpreis = '';
      betrag.parentElement.after(zusatz);
    }
    zusatz.textContent = auf ? (this.dataset.aufpreisText || 'inkl. {betrag} fürs Anpassen')
      .replace('{betrag}', this.geld.format(auf / 100)) : '';
    zusatz.hidden = !auf;
    this.knopf();
  }

  melden(text) {
    const f = this.$('[data-fehler]');
    f.textContent = text || '';
    f.hidden = !text;
  }

  async kaufen() {
    if (this.$('[data-kaufen]').disabled) return;
    const art = this.art;
    const w = this.w;
    const stempel = art === 'stempel';
    const eigenschaften = {
      ...(this.stempelEigenschaft ? { 'Ausführung': NAME[art] } : {}),     // die Fertigung liest sie (app.ausfuehrung)
    };
    const positionen = [];
    if (this.angepasst) {
      Object.assign(eigenschaften, {
        'Größe': `${zahl(w.l)} × ${zahl(this.kurz(w.l))} cm`,
        [stempel ? 'Höhe des Rings' : 'Schneidhöhe']: cm(stempel ? w.ring : w.h),
      });
      if (!stempel) eigenschaften.Stempeltiefe = `${w.t} mm`;
      // für die Fertigung, ohne http (sonst nähme der Bestellabruf es als Kundenfoto); x, y = Mitte des Textes in mm
      // wie auf dem Keks (x nach rechts, y nach unten) vom Ursprung der Grundrisse, text URL-kodiert
      let anpassung = `l=${w.l};h=${stempel ? w.ring : w.h};t=${stempel ? '' : w.t};a=${art};v=${STAND}`;
      const t = this.textAntwort;
      if (this.textWert && t) {
        eigenschaften.Text = t.t.replace(/\n/g, ' / ');
        eigenschaften.Schrift = `${this.schriftNamen[t.s] || t.s}, ${t.g} mm`;
        // w = Drehung in Grad im Uhrzeigersinn wie auf dem Keks (rotate der Keks-Ansicht, die Grundrisse sind um 180° gedreht)
        anpassung += `;text=${encodeURIComponent(t.t)};s=${t.s};g=${t.g};x=${+(-this.lage.x).toFixed(2)};y=${+(-this.lage.y).toFixed(2)};w=${this.winkel}`;
        if (this.winkel) eigenschaften.Drehung = `${Math.abs(this.winkel)}° ${this.winkel > 0 ? 'nach rechts' : 'nach links'}`;
      }
      eigenschaften['Keks-Garantie'] = 'entfällt (angepasst)';
      eigenschaften._Anpassung = anpassung;
      if (this.dataset.aufpreisVariante) {
        // _Aufpreis: der Warenkorb zählt ihn nicht als Ausstecher (keks-stueckzahl, keks-shop.js › stueckZaehlen); im
        // Rabatt „4 für 3“ ist er nie, solange sein Titel nicht „Keksausstecher“ enthält (Kollektionen nach Titel)
        positionen.push({ id: Number(this.dataset.aufpreisVariante), quantity: 1,
          properties: { _Zu: `${this.dataset.sku} ${eigenschaften.Text || ''}`.trim(), _Aufpreis: 'Anpassen' } });
      }
    }
    // Shopify legt die Zeilen einer Anfrage von hinten nach vorn oben in den Warenkorb: Aufpreis zuerst, dann steht er
    // direkt unter dem Ausstecher
    const ausstecher = { id: Number(this.varianten[art]), quantity: 1, properties: eigenschaften };
    positionen.push(ausstecher);
    window.keksAusfuehrung?.merken(NAME[art]);        // sonst tauscht keks-ausfuehrung-merken die Variante
    const knopf = this.$('[data-kaufen]');
    const text = this.$('[data-knopf]');
    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');
    try {
      const { inDenWarenkorb, aufpreisPaar } = await import(this.dataset.shopJs);
      // _Paar: der Warenkorb zieht den Aufpreis mit Menge und Löschen des Ausstechers mit (keks-shop.js › aufpreisPruefen)
      if (positionen.length > 1 && aufpreisPaar) {
        positionen[0].properties._Paar = aufpreisPaar(ausstecher.id, ausstecher.properties._Anpassung);
      }
      await inDenWarenkorb(positionen, this);
      this.melden('');
      const vorher = text.textContent;
      text.textContent = 'Im Warenkorb ✓';
      setTimeout(() => { text.textContent = vorher; }, 2000);
    } catch (f) {
      this.melden(f.message);
    } finally {
      knopf.removeAttribute('aria-busy');
      this.knopf();
    }
  }
}

if (!customElements.get('keks-anpassen')) customElements.define('keks-anpassen', KeksAnpassen);
